import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
// router
import { BrowserRouter, Route, Routes, Navigate } from "react-router";
// redux
import { Provider } from 'react-redux';
import { store } from './store/store';
// mui
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';
// pages
import PageNotFound from './pages/PageNotFound';
import LandingPage from './pages/LandingPage';
import AuthPage from './pages/auth/AuthPage';
import TasksPage from './pages/app/TasksPage';
import AppLayout from './layouts/AppLayout';
import ToDoPage from './pages/app/ToDoPage';
import BugReportPage from './pages/app/BugReportPage';
import EmailConfirmationPage from './pages/auth/EmailConfirmationPage';
import FeedbackPage from './pages/app/FeedbackPage';
import DashboardPage from './pages/app/DashboardPage';
import UpcomingPage from './pages/app/UpcomingPage';
import SettingsPage from './pages/app/Settings';
import ResetPasswordPage from './pages/auth/ResetPasswordPage';

const rootElement = document.getElementById('root');
const root = ReactDOM.createRoot(rootElement!);

root.render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/auth">
            <Route index element={<AuthPage />} />
            <Route path="confirm" element={<EmailConfirmationPage />} />
            <Route path="reset" element={<ResetPasswordPage />} />
          </Route>
          <Route path="/app">
            <Route element={<AppLayout />}>
              <Route index element={<Navigate to="tasks" replace />} />
              <Route path="tasks" element={<TasksPage />} />
              <Route path="todo" element={<ToDoPage />} />
              <Route path="upcoming" element={<UpcomingPage />} />
              <Route path="dashboard" element={<DashboardPage />} />
              <Route path="bugreport" element={<BugReportPage />} />
              <Route path="feedback" element={<FeedbackPage />} />
              <Route path="settings" element={<SettingsPage />} />
            </Route>
          </Route>
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  </Provider>,
);
